/* eslint-disable max-len */
import { ActivityImpactInUnderstandableUnits } from "../domain";

export const createSentenceOfUnderstandableUnits =
  ({ name, value, treesEquivalentValue}: ActivityImpactInUnderstandableUnits) =>
    name
      .replace('{value}', Math.round(value).toLocaleString())
      .replace('{treesEquivalentValue}', Math.round(treesEquivalentValue).toLocaleString());